<div class="top-content">
  <p
    class="title"
    style="cursor: pointer"
    data-remote="true"
    (click)="viewProposal()"
  >
    {{
      proposal.title.length > 70
        ? (proposal.title | slice: 0:69) + "..."
        : proposal.title
    }}
  </p>
  <p class="description"
     style="cursor: pointer"
     data-remote="true"
     (click)="viewProposal()">{{ proposal.description }}</p>
</div>
<div class="bottom-content">
  <div class="navbar-fixed-bottom navbar-fixed-bottom-bg-{{ colorOption }}">
    <div class="navbar-inner">
      <div class="pull-left">
        <span
          *ngIf="showVotes"
          class="badge badge-success"
          title="Votos totales"
          >{{ proposal.totalVotes }}</span
        >
        <span *ngIf="showMyVotes"
              class="badge badge-inverse"
              title="Mis votos"
        >{{proposal.userVotes}}
        </span>
        <span [hidden]="hideButtons"
          class="badgeicons material-icons"
          title="Sumar un Voto"
          (click)="vote()"
          >thumb_up</span
        >
        <span [hidden]="hideButtons"
          class="badgeicons material-icons"
          title="Quitar un Voto"
          (click)="unvote()"
          >thumb_down</span
        >
      </div>
      <div class="pull-right">
        <span class="badge badge-info">{{ proposal.totalComments }}</span>
        <span
          class="badgeicons material-icons"
          (click)="viewComments()"
          title="Ver Todos los Comentarios"
          >question_answer</span
        >
      </div>
    </div>
  </div>
</div>
